import type { HTMLTagAttributes } from './html-tag-attributes';

export class HTMLTag {
  tag: string;
  attributes: HTMLTagAttributes;

  constructor(params: { tag: string; attributes: HTMLTagAttributes }) {
    this.tag = params.tag;
    this.attributes = params.attributes;
  }

  get isHreflangLink(): boolean {
    return this.tag === 'link' && this.attributes.rel === 'alternate' && !!this.attributes.hreflang;
  }

  get isCanonicalLink(): boolean {
    return this.tag === 'link' && this.attributes.rel === 'canonical';
  }

  get isMetaTag(): boolean {
    return this.tag === 'meta';
  }

  hasName(name: string): boolean {
    return this.attributes.name === name;
  }

  hasProperty(property: string): boolean {
    return this.attributes.property === property;
  }

  contentIsEmpty(): boolean {
    return !this.attributes.content;
  }
}
